export default "/_next/static/images/createDesignWrapper-f81e383013872c88e236499a6acfef29.png";